import { render, staticRenderFns } from "./ConfigTestes.vue?vue&type=template&id=3dc21ee6"
import script from "./ConfigTestes.vue?vue&type=script&lang=js"
export * from "./ConfigTestes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports